import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';

import { disciplinesList } from '../../../aliases';
import { formatDateTime } from '../../../tools/converters';
import Pocket from '../Pocket';

export default function PocketGofTournaments() {
    return (
        <Pocket
            isFlex
            itemsLimit={150}
            endpoint="v2/gof.vkplay.ru/pockets/gof-tournaments/"
            formFields={[
                {
                    type: 'textarea',
                    name: 'name',
                    label: 'Название турнира',
                    maxLength: 128,
                    textareaRows: 3,
                    isRequired: true,
                    isMultilang: true,
                },
                {
                    type: 'input',
                    name: 'link',
                    label: 'Ссылка',
                    maxLength: 255,
                    isRequired: true,
                    isMultilang: true,
                },
                {
                    type: 'select',
                    name: 'discipline',
                    label: 'Дисциплина',
                    isRequired: true,
                    staticSelectData: disciplinesList,
                },
                {
                    type: 'date-time',
                    name: 'start',
                    label: 'Начало турнира',
                    isRequired: true,
                },
                {
                    type: 'date-time',
                    name: 'finish',
                    label: 'Завершение турнира',
                    isRequired: true,
                },
                {
                    type: 'input',
                    name: 'participants_count',
                    label: 'Количество участников',
                    maxLength: 255,
                },
                {
                    type: 'input',
                    name: 'prize_fund',
                    label: 'Призовой фонд',
                    maxLength: 255,
                },
            ]}
            renderColumns={({ editItem, deleteItem }) => ([
                {
                    Header: 'Название турнира',
                    sortable: false,
                    accessor: 'content.ru.name',
                    maxWidth: 440,
                    getProps: () => ({
                        style: {
                            whiteSpace: 'pre-wrap',
                        },
                    }),
                },
                {
                    Header: 'Дисциплина',
                    sortable: false,
                    accessor: 'discipline.name',
                    maxWidth: 120,
                },
                {
                    Header: 'Начало турнира',
                    sortable: false,
                    accessor: 'start',
                    maxWidth: 150,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Завершение турнира',
                    sortable: false,
                    accessor: 'finish',
                    maxWidth: 150,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Количество участников',
                    sortable: false,
                    accessor: 'participants_count',
                    maxWidth: 150,
                },
                {
                    Header: 'Призовой фонд',
                    sortable: false,
                    accessor: 'prize_fund',
                    maxWidth: 150,
                },
                {
                    Header: '',
                    sortable: false,
                    accessor: 'id',
                    maxWidth: 70,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-value={row.value}
                                    onClick={editItem}
                                >
                                    <FontAwesomeIcon id={row.row.id} data-value={row.value} icon="pencil-alt" />
                                </Button>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-title={row.original.title}
                                    data-value={row.value}
                                    onClick={deleteItem}
                                >
                                    <FontAwesomeIcon id={row.row.id} data-value={row.value} icon="trash" />
                                </Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                },
            ])}
        />
    );
}
